import { useEffect } from "react";
import { meGQL, Query } from "@onmo/graphql/graphql";
import { Outlet } from "react-router-dom";
import { loginGQL, useLegacyMutation } from "@onmo/graphql/legacyGraphql";
import i18next from "i18next";
import { useLazyQuery } from "@apollo/client";
import { PageRoutes } from "../constants/routes";

export const AuthenticatedLayout = () => {
  const [getMe, { data: dataMe }] = useLazyQuery<{ me: Query["me"] }>(meGQL);
  const [login] = useLegacyMutation(loginGQL);

  useEffect(() => {
    const loginPromise = async () => {
      if (window.location.pathname !== PageRoutes.Home) {
        await login();
      }
      await getMe();
    };
    loginPromise();
  }, [login, getMe]);

  useEffect(() => {
    if (dataMe?.me?.language) {
      i18next.changeLanguage(dataMe.me.language);
      localStorage.setItem("app_language", dataMe.me.language);
    }
  }, [dataMe?.me?.language]);

  return <Outlet />;
};
